// Product energy restriction helpers (mirror of backend fuel_restriction.py)
export const ENERGIES = ['essence', 'diesel', 'electrique'];

const ascii = (s) => String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

// Vehicle engine fuel (« essence », « diesel/électrique », « hybride », « gpl »…) → essence | diesel | electrique | null
export const vehicleEnergy = (fuel) => {
  const f = ascii(fuel);
  if (!f) return null;
  if (/diesel|gazole|gasoil/.test(f)) return 'diesel';
  if (/essence|petrol|gasol|benzin|gpl|lpg|ethanol|hybrid/.test(f)) return 'essence';
  if (/electr|elettr|elektr/.test(f)) return 'electrique';
  return null;
};

export const productFuelOk = (product, energy) => {
  const types = product?.fuel_types || [];
  return !types.length || !energy || types.includes(energy);
};

export const energyLabel = (t, energy) => t(`fuelR.${energy}`);
export const fuelTypesLabel = (t, types) => (types?.length ? ENERGIES.filter(e => types.includes(e)).map(e => energyLabel(t, e)).join(' · ') : t('fuelR.all'));

// Relevance: parts made for the vehicle's energy first, then universal ones (stable)
export const sortByEnergy = (list, energy) => (energy ? list.map((p, i) => [p, i]).sort((a, b) => ((a[0].fuel_types || []).includes(energy) ? 0 : 1) - ((b[0].fuel_types || []).includes(energy) ? 0 : 1) || a[1] - b[1]).map(x => x[0]) : list);
